import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  image: string;
  date: string;
  readTime: string;
}
interface BlogCardProps {
  post: BlogPost;
  index: number;
}
export function BlogCard({
  post,
  index
}: BlogCardProps) {
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.5,
    delay: index * 0.05
  }} className="group flex flex-col h-full bg-white rounded-xl overflow-hidden hover:shadow-lg transition-all duration-300 hover:-translate-y-1 border border-transparent hover:border-slate-100" data-id="element-1">
      {/* Image Container */}
      <div className="relative aspect-[16/10] overflow-hidden bg-slate-100" data-id="element-2">
        <img src={post.image} alt={post.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-3" />
      </div>

      {/* Content */}
      <div className="flex-1 p-6 flex flex-col" data-id="element-4">
        <div className="flex items-center justify-between mb-4" data-id="element-5">
          <span className="inline-block px-2.5 py-0.5 text-xs font-medium uppercase tracking-wide rounded-full bg-slate-100 text-slate-600" style={{
          fontFamily: "'Poppins', sans-serif"
        }} data-id="element-6">
            {post.category}
          </span>
          <span className="text-xs text-slate-400 font-light" style={{
          fontFamily: "'Poppins', sans-serif"
        }} data-id="element-7">
            {post.readTime}
          </span>
        </div>

        <h3 className="text-xl font-medium text-[#1a365d] mb-3 leading-snug group-hover:text-[#c73e4c] transition-colors" style={{
        fontFamily: "'Poppins', sans-serif"
      }} data-id="element-8">
          {post.title}
        </h3>

        <p className="text-slate-500 text-sm leading-relaxed mb-6 flex-1 font-light" style={{
        fontFamily: "'Poppins', sans-serif"
      }} data-id="element-9">
          {post.excerpt}
        </p>

        <div className="mt-auto pt-4 border-t border-slate-50 flex items-center justify-between" data-id="element-10">
          <span className="text-xs text-slate-400 font-light" style={{
          fontFamily: "'Poppins', sans-serif"
        }} data-id="element-11">
            {post.date}
          </span>
          <span className="inline-flex items-center text-sm font-medium text-[#1a365d] group-hover:translate-x-1 transition-transform duration-300" style={{
          fontFamily: "'Poppins', sans-serif"
        }} data-id="element-12">
            Read <ArrowRight className="ml-1.5 w-3.5 h-3.5" data-id="element-13" />
          </span>
        </div>
      </div>
    </motion.article>;
}